import * as React from 'react';
import { List, Datagrid, TextField, DateField, SelectField } from 'react-admin';
import { units } from '../types';

export const ProductList = (props: any) => (
  <List {...props} sort={{ field: 'name,variant', order: 'ASC,ASC' }}>
    <Datagrid bulkActionButtons={null} rowClick="edit">
      <TextField source="name" label="resources.productvariants.fields.product" />
      <TextField source="variant" />
      <SelectField source="unit" choices={units} />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </Datagrid>
  </List>
);
